import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserAccount } from '../../services/userServices';
import { toAuthState } from '../../dto/auth.dto';

const initialState = {
  isLoading: false,
  isAuthenticated: false,
  account: {},
  userData: {},
  adminData: {},
};

export const fetchUserAccount = createAsyncThunk(
  'admin/fetchUserAccount',
  async (_, { rejectWithValue }) => {
    try {
      const state = toAuthState(await getUserAccount(), 'admin');
      return state || rejectWithValue({ isAuthenticated: false });
    } catch (error) {
      return rejectWithValue({ isAuthenticated: false });
    }
  },
);

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    login: (_, action) => action.payload,
    logout: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAccount.pending, (state) => { state.isLoading = true; })
      .addCase(fetchUserAccount.fulfilled, (_, action) => action.payload)
      .addCase(fetchUserAccount.rejected, () => initialState);
  },
});

export const { login, logout } = adminSlice.actions;
export default adminSlice.reducer;
